import React, { useState } from "react";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import axios from "axios";
import config from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import LoadingSpinner from "../Components/LoadingSpinner";

const DeleteModal = (props) => {
  const { deleteModal , setDeleteModal, rowsId, setReloadData } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseModal = () => {
    setDeleteModal(false);
  };

  const DeleteData = async () => {
    setIsLoading(true);
    let path = config.siteUrl;
    var result = await axios
      .get(
        path + `/common/delete-holiday/${rowsId}`,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      )
      .then((response) => {
        toast.success(response?.data?.message)
        setIsLoading(false) 
        setReloadData(true);
        return response.data; 
      })
      .catch((error) => {
        console.error("error:", error); 
        return null;
      });
    return result;
  };

  return (
    <>
      <div>
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={deleteModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title className="text-center w-100">
              Are You Sure to Delete this Data
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <div className="alert-modal-box mt-2">
                  <p><strong>Proceed?!</strong></p>
                  <p><strong>This action cannot be undone</strong>, are you sure you wish to proceed?!</p>
                </div>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" 
                onClick={() => {
                    DeleteData();
                    handleCloseModal();
                }}
            >
              Proceed
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default DeleteModal;
